import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-auth-footer',
  imports: [CommonModule],
  template: `
    <footer class="bg-white border-t border-gray-200 mt-auto">
      <div class="container mx-auto px-4 py-6">
        <!-- Social Media Links -->
        <div class="flex justify-center space-x-6 mb-4">
          <a
            href="https://facebook.com/wallstyardie"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-jamaica-green-600 transition-colors"
            aria-label="Follow us on Facebook"
          >
            <i class="fa-brands fa-square-facebook text-2xl"></i>
          </a>
          <a
            href="https://twitter.com/wallstyardie"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-jamaica-green-600 transition-colors"
            aria-label="Follow us on Twitter"
          >
            <i class="fa-brands fa-square-twitter text-2xl"></i>
          </a>
          <a
            href="https://instagram.com/wallstyardie"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-jamaica-green-600 transition-colors"
            aria-label="Follow us on Instagram"
          >
            <i class="fa-brands fa-square-instagram text-2xl"></i>
          </a>
          <a
            href="https://youtube.com/@wallstyardie"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-jamaica-green-600 transition-colors"
            aria-label="Subscribe to our YouTube channel"
          >
            <i class="fa-brands fa-square-youtube text-2xl"></i>
          </a>
        </div>

        <!-- Footer Links -->
        <div class="text-sm text-center text-gray-600 mb-4">
          <a href="https://www.wallstyardie.com/disclaimer" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Disclaimer</a> •
          <a href="https://www.wallstyardie.com/terms" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Terms</a> •
          <a href="https://www.wallstyardie.com/privacy" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Privacy</a> •
          <a href="https://www.wallstyardie.com/do-not-sell" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Do Not Sell</a> •
          <a href="https://www.wallstyardie.com/refund" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Refund</a> •
          <a href="https://www.wallstyardie.com/cookies" target="_blank" rel="noopener noreferrer" class="hover:text-jamaica-green-600 transition-colors">Cookies</a>
        </div>

        <!-- Copyright -->
        <div class="text-xs text-gray-500 text-center">
          <p>&copy; 2025-{{ currentYear }} Wall St. Yardie Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthFooterComponent {
  currentYear = new Date().getFullYear();
}
